import { Component, Element, Listen } from '@stencil/core';

declare global {
    interface Window { PSC: any; }
}

@Component({
  styleUrls: {
    default: 'igws-ls.default.less',
    rtl: 'igws-ls.rtl.less',
    rebrand: 'igws-ls.default.less',
    rtl_rebrand: 'igws-ls.rtl.less',
    prime: 'igws-ls.default.less',
    rtl_prime: 'igws-ls.rtl.less',
    investments: 'igws-ls.default.less',
    rtl_investments: 'igws-ls.rtl.less',
    helpandsupport: 'igws-ls.default.less',
    rtl_helpandsupport: 'igws-ls.rtl.less',
    academy: 'igws-ls.default.less',
    rtl_academy: 'igws-ls.rtl.less',
    landingpages: 'igws-ls.default.less',
    rtl_landingpages: 'igws-ls.rtl.less',
    generic: 'igws-ls.default.less',
    rtl_generic: 'igws-ls.rtl.less',
  },
  tag: 'igws-ls',
})
export class LanguageSwitcherComponent {

  @Element() el!: HTMLIgwsLsElement;

  @Listen('click', {})
  handleClick(event: UIEvent) {
    event.preventDefault();
    const el = event.target as HTMLElement | HTMLAnchorElement;
    const link = el.querySelector('a');
    const value = el.classList.contains('ls__option') ? link && link.getAttribute('href') : el.getAttribute('href');
    if (el.classList.contains('ls__styled')) {
      el.classList.toggle('open');
      const selectedElement: HTMLElement = this.el.querySelector('.ls__options') as HTMLElement;
      selectedElement.classList.add('animate');
    }
    if (value && !el.classList.contains('active')) {
      window.PSC.Cookie.set('lang_sw', value, 30);
      window.location.href = value;
    }
  }

  render() {}
}
